import request from "@/utils/request";


export const submitFeedback = (params: any) => {
    return request.post("/feedback", {
        data: params,
    });
};

// 投诉与反馈列表（管理端）
export const getFeedbackWebList = (params: any) => {
    return request.post("/feedback/list", {
        data: params,
    });
};

// 投诉与反馈详情
export const getFeedbackWebDetail = (params: { feedbackId: string }) => {
    return request.post("/feedback/detail", {
        data: params,
    });
};

// 修改投诉与反馈处理状态
export const changeFeedbackStatus = (params: {
    feedbackId: string;
    disposeStatus: number;
    modifier?: string;
}) => {
    return request.post("/feedback/changeStatus", {
        data: params,
    });
};

// 投诉与反馈导出
export const exportFeedbackWebList = (params: any) => {
    return request.post("/feedback/export", {
        data: params,
        responseType: "blob",
    });
};
// 获取权限列表
export const getResource = (params: any) => {
    return request.post("/resource/getResource", {
        data: params,
    });
};

